import { createStyles } from 'antd-style';

import { ThemeFont } from '../theme';

export const useTooltipStyles = createStyles(({ token }) => ({
  customLines: {
    maxWidth: 'none',
    whiteSpace: 'pre-line',
  },
  sm: {
    '&& .ant-tooltip-inner': {
      borderRadius: token.borderRadiusSM,
      fontSize: ThemeFont.FONT_SIZE_SM_MINUS,
      fontFamily: ThemeFont.FONT_FAMILY4,
      lineHeight: 1.5,
      fontWeight: 'bold',
      padding: `${token.paddingXS}px ${token.paddingSM}px`,
      boxShadow: 'none',
    },
  },
  textCenter: {
    '.ant-tooltip-inner': {
      textAlign: 'center',
    },
  },
}));
